import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStoreActions } from "app/utils/hooks";
import { fetchSports } from "app/actions/sports";
import { cls } from "app/utils";
import styles from "./styles.module.scss";

interface IProps {
  selectedSport?: string;
  onSelect?: (_sport: string) => void;
}

const CreateSpaceConfig = ({ selectedSport: initialSport, onSelect }: IProps) => {
  const { t } = useTranslation();
  const { sports } = useStoreActions(
    { sports: fetchSports },
    { noAuth: true },
  );
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSport, setSelectedSport] = useState<string | null>(initialSport || null);
  const selectRef = useRef<HTMLDivElement>(null);

  // Sync from workflow prop when it changes (e.g. after re-fetch or remount)
  useEffect(() => {
    if (initialSport && !selectedSport) {
      setSelectedSport(initialSport);
    }
  }, [initialSport]);

  const sportsList: string[] = sports?.data || [];

  const handleSelect = (sport: string) => {
    setSelectedSport(sport);
    setIsOpen(false);
    onSelect?.(sport);
  };

  const handleBlur = (e: React.FocusEvent) => {
    if (
      selectRef.current &&
      !selectRef.current.contains(e.relatedTarget as Node)
    ) {
      setIsOpen(false);
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>
        {t(
          "Choose a sport for the Spaces that will be created based on this workflow.",
        )}
      </p>

      <span className={styles.label}>{t("Sport")}</span>

      <div
        className={styles.select_wrapper}
        ref={selectRef}
        onBlur={handleBlur}
      >
        <button
          className={cls(styles.select_btn, { [styles.open]: isOpen })}
          onClick={() => setIsOpen(!isOpen)}
          type="button"
        >
          <span
            className={cls({
              [styles.placeholder]: !selectedSport,
            })}
          >
            {selectedSport || t("Select")}
          </span>
          <i
            className={cls("ico", "ico-chevron", styles.chevron, {
              [styles.chevron_open]: isOpen,
            })}
          />
        </button>

        {isOpen && (
          <div className={styles.options_list}>
            {sports?.pending && (
              <div className={styles.option_loading}>{t("Loading...")}</div>
            )}
            {sportsList.map((sport) => (
              <div
                key={sport}
                className={cls(styles.option_item, {
                  [styles.option_selected]: sport === selectedSport,
                })}
                onMouseDown={() => handleSelect(sport)}
              >
                {sport}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateSpaceConfig;
